// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_SC","alignRight":"e_TC","alignLeft":"e_UC","item":"e_VC","icon":"e_WC","soft":"e_XC"};